// extracted by mini-css-extract-plugin
export default {"pageWrap":"_c-z","fullWidth":"ad-z","heading":"bd-z","fullBleed":"cd-z","hidden":"dd-z"};